export default "__VITE_ASSET__4vXbpDn7__"